import { render, staticRenderFns } from "./Rechange.vue?vue&type=template&id=2723df74&scoped=true&"
import script from "./Rechange.vue?vue&type=script&lang=js&"
export * from "./Rechange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723df74",
  null
  
)

export default component.exports